module.exports = __webpack_public_path__ + "img/portrait.0fb7efa5.png";